export class Address {
    street: String;
    number: String;
    complement: String;
    city: String;
    uf: String;
    zipCode: String;
    district: String;
    type: String;

    loadToEdit(a: any) {
        this.street = a.street;
        this.number = a.number;
        this.complement = a.complement;
        this.city = a.city;
        this.uf = a.uf;
        this.zipCode = a.zipCode;
        this.district = a.district;
        this.type = a.type;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Address.model.ts